import Vue from 'vue'
import Router from 'vue-router'
import i18n from '../lang/index'
import util from '../utils/util'
import hostRouter from "./modules/host"
import serverRouter from "./modules/server"
import bareRouter from "./modules/baremetal"
import sqlRouter from "./modules/sql"
import slbRouter from "./modules/slb"
import userRouter from "./modules/user"
import dmsRouter from "./modules/dms"
import sslRouter from "./modules/ssl"
import billingRouter from "./modules/billing"
import ipRouter from "./modules/ip"
import lightServerRouter from "./modules/lightServer"
import referralRouter from "./modules/referral"
i18n.locale = util.getCookie("locale") || 'en';


const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routerOptions = {
  mode: 'history',
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('@/pages/Index'),
      redirect: {
        path: '/overview'
      }
    },
    ...hostRouter,
    ...serverRouter,
    ...bareRouter,
    ...sqlRouter,
    ...slbRouter,
    ...userRouter,
    ...dmsRouter,
    ...sslRouter,
    ...billingRouter,
    ...ipRouter,
    ...lightServerRouter,
    ...referralRouter
  ]
}
const router = new Router(routerOptions)

// 导航拦截
router.beforeEach((to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title+' - '+i18n.t('common.siteName');
  } else {
    document.title = i18n.t('common.siteName');
  }
  next()
})

Vue.use(Router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js